import { render, staticRenderFns } from "./merchantList.vue?vue&type=template&id=1e78463b"
import script from "./merchantList.vue?vue&type=script&lang=ts"
export * from "./merchantList.vue?vue&type=script&lang=ts"
import style0 from "./merchantList.vue?vue&type=style&index=0&id=1e78463b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports